'use client';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { Box, Typography } from '@mui/material';

import { colors } from '@/styles/theme';

interface PercentageDisplayProps {
  percentage: number;
  change?: number; // Percentage change (positive or negative)
}

export function PercentageDisplay({ percentage, change }: PercentageDisplayProps) {
  const hasChange = change !== undefined && change !== 0;
  const isPositive = change !== undefined && change > 0;
  const displayChange = change !== undefined ? Math.abs(change) : 0;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        mb: 2,
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: '2rem', sm: '3rem', md: '4rem' },
          fontWeight: 700,
          color: colors.info.main,
          lineHeight: 1,
        }}
      >
        {Math.round(percentage * 100)}% chance
      </Typography>
      {hasChange && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            color: isPositive ? '#4ec38a' : '#e0664f',
          }}
        >
          {isPositive ? (
            <ArrowUpwardIcon sx={{ fontSize: '1.5rem' }} />
          ) : (
            <ArrowDownwardIcon sx={{ fontSize: '1.5rem' }} />
          )}
          <Typography
            sx={{
              fontSize: { xs: '1rem', sm: '1.25rem' },
              fontWeight: 600,
              color: isPositive ? '#4ec38a' : '#e0664f',
            }}
          >
            {isPositive ? '+' : '-'}
            {displayChange}%
          </Typography>
        </Box>
      )}
    </Box>
  );
}
